import AgenliteAPIClient from '~/api';
import { CLIENT_KYC_CONFIRMATION } from '~/constants/mitra/agent';

const initialState = {
  kycBasic: {},
  singleKYCBasic: {},
};

const getters = {
  getKYCBasic(state) {
    return state.kycBasic;
  },
  isKYCVerified(state) {
    return state.kycBasic?.state === 'verified';
  },
  isStandardizeKYCBasicVerified(state) {
    return state.standardizeKYCBasic?.state?.basic === 'verified';
  },
  getSingleKYCBasic(state) {
    return state.singleKYCBasic;
  },
  getKycConfirmStatus(state) {
    return localStorage[`${CLIENT_KYC_CONFIRMATION}:${state.singleKYCBasic?.user_id}`];
  },
};

const mutations = {
  setKYCBasic(state, kycBasic) {
    state.kycBasic = kycBasic;
  },
  setStandardizeKYC(state, standardizeKYC) {
    state.standardizeKYCBasic = standardizeKYC;
  },
  setSingleKYCBasic(state, singleKYCBasic) {
    state.singleKYCBasic = singleKYCBasic;
  },
  setKycConfirmStatus(state, kycConfirmStatus) {
    localStorage[`${CLIENT_KYC_CONFIRMATION}:${state.singleKYCBasic?.user_id}`] = kycConfirmStatus;
  },
};

const actions = {
  async fetchMitraKYC({ commit, dispatch }) {
    let response = null;
    // eslint-disable-next-line no-console
    console.log('Fetching Mitra KYC data...');
    try {
      response = await AgenliteAPIClient.getMitraKYC();
      commit('setKYCBasic', response.data);
    } catch (error) {
      const message = 'Gagal mendapatkan data KYC basic.';
      dispatch('catchError', { error, message, noFlashAlert: true }, { root: true });
      throw error;
    }
    return response?.data;
  },

  async fetchStandardizeKYC({ commit, dispatch }) {
    let response = null;
    // eslint-disable-next-line no-console
    console.log('Fetching Standardize KYC data...');
    try {
      response = await AgenliteAPIClient.getStandardizeKYC();
      commit('setStandardizeKYC', response.data);
    } catch (error) {
      const message = 'Gagal mendapatkan data KYC basic.';
      dispatch('catchError', { error, message, noFlashAlert: true }, { root: true });
      throw error;
    }
    return response?.data;
  },
  async fetchMitraSingleKYC({ commit, dispatch }) {
    let response = null;
    try {
      response = await AgenliteAPIClient.getMitraSingleKYC();
      commit('setSingleKYCBasic', response.data);
    } catch (error) {
      const message = 'Gagal mendapatkan data KYC Mitra Perseorangan.';
      dispatch('catchError', { error, message, noFlashAlert: true }, { root: true });
      throw error;
    }
    return response?.data;
  },
};

export default {
  state: () => ({ ...initialState }),
  getters,
  actions,
  mutations,
};
